import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import IncomeStatement from "../../../containers/modules/report/income-statement";

export default function IncomeStatementRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="income-statement"
      index
      element={
        <AccessControl
          name={"Income Statement Show"}
          auth={authUser}
          component={() => <IncomeStatement />}
        />
      }
    ></Route>
  );
}
